import { ROUTES } from "../../routes/path";
import LegalPage from "./common/LegalPage";

const DOC = {
  title: "Terms and Conditions",
  tagline: "The rules for using the Global Tech9 LLC website.",
  effective: "October 21, 2026",
  intro:
    "Please read these Terms carefully. By accessing or using this website, you agree to be bound by them. If you do not agree, please do not use the website.",
  sections: [
    {
      id: "intro",
      title: "Introduction and Contracting Entity",
      blocks: [
        {
          t: "p",
          text: 'These Terms and Conditions ("Terms") apply to your use of the website operated under the "Global Tech9 LLC" brand (the "Website"). The Website is operated by Global Tech9 LLC, a limited liability company registered in Austin, Texas, USA ("we", "us", and "our"). "You" means the person or organization using the Website. If you use the Website on behalf of a company, you confirm that you have authority to bind that company to these Terms.',
        },
      ],
    },
    {
      id: "services",
      title: "Our Services and Website Content",
      blocks: [
        {
          t: "p",
          text: "This Website describes our services in IT infrastructure, artificial intelligence (AI), robotics, and related solutions. The information provided is general, is for information purposes only, and may change without notice. Nothing on this Website is a binding offer, quotation, or guarantee of any result, specification, or availability.",
        },
        {
          t: "p",
          text: "Specific services are provided only under a separate written agreement, quotation, or Statement of Work that sets out the scope, price, schedule, and warranty. If these Terms conflict with a signed written service agreement, the written agreement prevails for those services.",
        },
      ],
    },
    {
      id: "use",
      title: "Acceptable Use",
      blocks: [
        {
          t: "p",
          text: "You agree to use the Website only for lawful purposes and in line with these Terms. You must not:",
        },
        {
          t: "ul",
          items: [
            [
              "",
              "Attempt to gain unauthorized access to the Website, our servers, or any connected systems;",
            ],
            [
              "",
              "Introduce malware, or interfere with or disrupt the Website's operation or security;",
            ],
            [
              "",
              "Use automated tools (such as scrapers or bots) to extract content in bulk without our written permission;",
            ],
            [
              "",
              "Use the Website in a way that infringes the rights of others or breaks any applicable law, including U.S. export control and sanctions laws.",
            ],
          ],
        },
      ],
    },
    {
      id: "ip",
      title: "Intellectual Property",
      blocks: [
        {
          t: "p",
          text: "The content of this Website, including text, logos, trademarks, design, graphics, and images, belongs to Global Tech9 LLC or our licensors, and is protected by intellectual property laws. All rights are reserved.",
        },
        {
          t: "p",
          text: "You may view and print pages for your own internal business evaluation. You may not copy, modify, distribute, republish, or reuse our content for any other commercial purpose without our express written permission. Third-party names and trademarks mentioned on the Website belong to their respective owners.",
        },
      ],
    },
    {
      id: "enquiries",
      title: "Enquiries and Feedback",
      blocks: [
        {
          t: "p",
          text: [
            "If you contact us, for example by email or WhatsApp, the information you send is handled as described in our ",
            { to: "/privacy-policy", label: "Privacy Policy" },
            ". Any ideas or feedback you volunteer about our services may be used by us without obligation to you, but this does not give us rights to your confidential information. Please do not send us confidential or sensitive information until a written confidentiality agreement is in place.",
          ],
        },
      ],
    },
    {
      id: "links",
      title: "Third-Party Links and Services",
      blocks: [
        {
          t: "p",
          text: "The Website may link to or rely on third-party services (for example, WhatsApp or Google Fonts). We do not control these services and are not responsible for their content, availability, or privacy practices. Your use of them is governed by their own terms.",
        },
      ],
    },
    {
      id: "liability",
      title: "Disclaimer and Limitation of Liability",
      blocks: [
        {
          t: "p",
          text: 'The Website and its content are provided "as is" and "as available". To the fullest extent permitted by law, we disclaim all warranties, express or implied, including warranties of accuracy, completeness, merchantability, fitness for a particular purpose, and uninterrupted or error-free availability.',
        },
        {
          t: "p",
          text: "To the maximum extent permitted by applicable law, Global Tech9 LLC, nor its members, managers, employees, or representatives, will be liable for any indirect, incidental, special, or consequential damages, or for loss of profits, data, or business, arising from your use of, or inability to use, the Website. Nothing in these Terms excludes or limits liability that cannot be excluded or limited under applicable law.",
        },
      ],
    },
    {
      id: "law",
      title: "Governing Law and Dispute Resolution",
      blocks: [
        {
          t: "p",
          text: "These Terms and any related disputes are governed by the laws of the State of Texas, USA, without regard to its conflict-of-laws rules. Exclusive jurisdiction and venue lie in the state or federal courts located in Travis County, Texas.",
        },
        {
          t: "p",
          text: "We encourage you to contact us first so that we can try to resolve any concern informally.",
        },
      ],
    },
    {
      id: "changes",
      title: "Changes to the Website and These Terms",
      blocks: [
        {
          t: "p",
          text: "We may update the Website or these Terms from time to time. The effective date at the top shows when the Terms were last revised. Your continued use of the Website after an update means you accept the revised Terms.",
        },
      ],
    },
    {
      id: "general",
      title: "General",
      blocks: [
        {
          t: "p",
          text: "If any provision of these Terms is found to be unenforceable, the remaining provisions stay in effect. Our failure to enforce a right is not a waiver of it. These Terms, together with our Privacy Policy, are the entire agreement between you and us regarding your use of the Website. You may not assign these Terms without our consent; we may assign them to an affiliate or successor.",
        },
      ],
    },
    {
      id: "contact",
      title: "Contact Information",
      blocks: [
        {
          t: "p",
          text: "If you have any questions about these Terms, please contact us:",
        },
        { t: "contact" },
      ],
    },
  ],
  footnote:
    "Questions about these terms? Use the contact details in section 11.",
  // The "Contact Information" cards read from here (instead of the shared Thane details in LegalPage.jsx)
  contact: {
    name: "Global Tech9 LLC",
    email: "contact@globaltech9.com",
    address: "5900 Balcones Drive STE 100, Austin, TX 78731, USA",
  },
};

const RELATED = {
  to: ROUTES.PRIVACY,
  title: "Privacy Policy",
  text: "How we collect, use and protect your information.",
};

export default function TermsConditions() {
  return <LegalPage icon="doc" related={RELATED} {...DOC} />;
}
